<template>
	<!-- Layout inner -->
  <div class="layout-inner explore_entity_result careers">
    <!-- Layout navbar -->
    <navbar></navbar>
    <!-- / Layout navbar -->
    <div class="layout-container">
      <div class="layout-content">

        <!--
      	<div class="hd_bar">
          <div class="hd_ic">
            <span class="ic-explore"></span>
          </div>
          <div class="hd_txt">
            <span class="title_txt float-left">Exploring Careers</span>
            <span class="title_txt float-right"><strong>{{total}}</strong> Careers</span>
          </div>
        </div>
        -->

        <!-- Filter, Search and Sort -->
        <template v-if="!showSkillProgressPopup">
          <div class="sub_hd_bar">

            <div class="sub_hd_ic">
              <span @click="isCareerFilterClicked = true" class="filter" v-if="(isCareerInterestEnabled || isIncomeRangeEnabled)">
                <span class="ic ic-filter" :class="selectedFilterCount() > 0 ? 'active' : ''"></span>
                <template v-if="!isCareerFilterClicked">
                  <span class="count" v-if="selectedFilterCount() > 0">
                    <span>{{selectedFilterCount()}}</span>
                  </span>
                </template>
              </span>
            </div>

            <div class="srh_bx">
              <input v-if="isSearchBarEnabled" type="text" class="search-input" placeholder="type to narrow results" v-on:keyup.enter="searchButtonClicked" v-model.trim="searchTerms"/>
              <span v-if="isSearchBarEnabled" @click="searchButtonClicked" class="search-icon">
                <i class="fa fa-search" aria-hidden="true"></i>
              </span>
            </div>

            <div class="sort_by" v-if="isSortByEnabled" @click="openSortByDropDown">
              <span class="sort_by_link">sort by</span>
            </div>

            <div class="list_info">
              Exploring {{total}} Careers</span>
            </div>

          </div>
        </template>

        <!-- Page content -->
        <div class="container-fluid flex-grow-1 pg_content_container" style="padding-top: 0px;">

          <template v-if="showSkillProgressPopup">
        		<explore-career-skill-progress
              :title="selectedCareer.name"
              :stream-id="planningStream.uuid"
              :career-id="selectedCareer.uuid"
              :skill-progress-target-id="skillProgressTargetId">
            </explore-career-skill-progress>
        	</template>

        	<template v-else>
	        	<template v-if="isCareerFilterClicked || isCareerSotrByClicked">
	        		<div class="container filter_selection_flds_container">
	        			<template v-if="isCareerFilterClicked">
		        			<template v-if="(showCategoryDropDown || showIncomeRangeDropDown)">
		        				<div v-if="isCareerInterestEnabled && showCategoryDropDown">
                      <div class="filter_fld_head">
                        <div class="hd_txt">Select {{careerInterestLabel}}</div>
                      </div>
		        					<div class="filter_fld_container" style="overflow-y: hidden;">
                        <template v-if="formattedFacetResults.careerCategory.length > 0">
                          <virtual-list
                            class="facet-item-list"
                            :data-key="'key'"
                            :data-sources="formattedFacetResults.careerCategory"
                            :data-component="careerCategoryItemComponent"
                            :extra-props="{parent: parentComponent}"
                          />
                        </template>
                      </div>
		          				<div class="btn_container">
				        				<b-btn @click="closeCategoryDropDown">ok</b-btn>
				        			</div>
		        				</div>
		        				<div v-if="isIncomeRangeEnabled && showIncomeRangeDropDown">
                      <div class="filter_fld_head">
                        <div class="hd_txt">Select {{incomeRangeLabel}}</div>
                      </div>
		        					<div class="filter_fld_container">
			        					<template v-for="range in formattedFacetResults.careerIncomeRange" >
			            				<label>
			            					<input type="radio" :checked="range.isSelected" @input.stop="filterSelected(range, 'careerIncomeRange')">
                              <span class="input_txt">
                                {{range.label}} <span v-if="showFacetCounts">[{{range.doc_count}}]</span>
                              </span>
			            					</input>
			            				</label>
			          				</template>
			          				<div class="mt-2 w-75">
		                 			<span>min</span>
		          						<b-form-input id="customIncomeMin" v-model="customIncomeMin" number="true" type="number" min="0"></b-form-input>
		          					</div>
		          					<div class="mt-3 w-75">
		                 			<span>max</span>
		          						<b-form-input id="customIncomeMax" v-model="customIncomeMax" number="true" type="number" min="0"></b-form-input>
		          					</div>
		        					</div>
		        	   			<div class="btn_container">
				        				<b-btn @click="customRangeSelected">ok</b-btn>
				        			</div>
		        				</div>
		        			</template>
		        			<template v-else>

                    <div class="filter_fld_head">
                      <div class="hd_txt">
                        Select Filter(s)
                      </div>
                    </div>

		        				<div class="filter_options_container">
				        			<div v-if="isCareerInterestEnabled" @click.stop="openCategoryDropDown" class="filter_option area_of_study">
				        				<label for="select-career">
				        					<span>Select </span>{{careerInterestLabel}}
				        				</label>
					        		</div>
					        		<div v-if="isIncomeRangeEnabled" @click.stop="openIncomeRangeDropDown" class="filter_option income_range">
			          				<label for="select-income">
			          					<span>Select </span>{{incomeRangeLabel}}
			          				</label>
				        			</div>
			        			</div>

                    <div class="selected_filters_container">
					    				<b-input-group>
					    					<template v-for="category in formattedFacetResults.careerCategory" v-if="!showCategoryDropDown">
				          			  <div v-if="category.isSelected" class="search_tag area_of_study">
				          			    <span class="title category">{{category.key}}</span>
				            			  <span class="ic_btn icon-bin" @click.stop="filterSelected(category, 'careerCategory')"></span>
				            		  </div>
				          			</template>
				          			<template v-for="range in formattedFacetResults.careerIncomeRange" v-if="!showIncomeRangeDropDown">
				          			  <div v-if="range.isSelected" class="search_tag income_range">
				          			    <span class="title income_range">{{range.label}}</span>
				            			  <span  class="ic_btn icon-bin" @click.stop="clearRangeFilter"></span>
				            			</div>
				          			</template>
                        <div v-if="careerSearchCustomIncomeMax && careerSearchCustomIncomeMin" class="search_tag">
                          <span class="title income_range">${{careerSearchCustomIncomeMin}} - ${{careerSearchCustomIncomeMax}}</span>
                          <span  class="ic_btn icon-bin" aria-label="delete" tabindex="0" @click.stop="clearRangeFilter"></span>
                        </div>
                        <div v-if="careerSearchCustomIncomeMax && !careerSearchCustomIncomeMin" class="search_tag">
                          <span class="title income_range"> < ${{careerSearchCustomIncomeMax}}</span>
                          <span  class="ic_btn icon-bin" aria-label="delete" tabindex="0" @click.stop="clearRangeFilter"></span>
                        </div>
                        <div v-if="!careerSearchCustomIncomeMax && careerSearchCustomIncomeMin" class="search_tag">
                          <span class="title income_range"> > ${{careerSearchCustomIncomeMin}}</span>
                          <span  class="ic_btn icon-bin" aria-label="delete" tabindex="0" @click.stop="clearRangeFilter"></span>
                        </div>
                        <div v-if="showInstitutionCareerFilter && isInstitutionCareersEnabled" class="search_tag">
                          <span class="title income_range"> {{institutionCareersLabel}}</span>
                          <span  class="ic_btn icon-bin" aria-label="delete" tabindex="0" @click.stop="clearInstitutionCareerFilter"></span>
                        </div>
                      </b-input-group>

                      <div v-if="selectedFilterCount() === 0" class="no_result">{{ $t('noFilterSelected') }}</div>

					   				</div>

			        			<div class="btn_container">
			        				<b-btn @click="isCareerFilterClicked = false">ok</b-btn>
			        			</div>

		        			</template>
	        			</template>
	        			<template v-if="isCareerSotrByClicked">
                  <div class="filter_fld_head">
                    <div class="hd_txt">Filter</div>
                  </div>
                  <div class="filter_row_container">
                    <div v-if="isInstitutionCareersEnabled && !showInstitutionCareerFilter" @click="institutionCareerFilterSelected">
                      <div class="field-row mb-3">
                        <div class="form-check">
                          <span class="ic9-checkbox-unchecked"></span>
                          <label class="form-check-label row_txt ml-1">{{institutionCareersLabel}}</label>
                        </div>
                      </div>
                    </div>
                    <div v-else @click="clearInstitutionCareerFilter">
                      <div class="field-row mb-3">
                        <div class="form-check">
                          <span class="ic9-checkbox-checked"></span>
                          <label class="form-check-label row_txt ml-1">{{institutionCareersLabel}}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="filter_fld_head">
                    <div class="hd_txt">
                      Sort by
                    </div>
                  </div>
	        				<div class="mt-2 ml-4">
	        					<template v-for="sort in sortByOptions">
			    						<div class="field-row mb-3">
			    							<div class="form-check">
			              			<input type="radio" class="form-check-input" :id="sort.name" :checked="selectedSort" v-model="selectedSort" v-bind:value="sort.clause">
			              			<label class="form-check-label" :for="sort.name">{{ sort.name }}</label>
			              		</div>
			              	</div>
			  						</template>
					  	      <div class="btn_container">
			        				<b-btn @click="closeSortByDropDown">ok</b-btn>
			        			</div>
	        				</div>
	        			</template>
	        		</div>
	        	</template>
	        	<template v-else>
	        		<template v-if="isResultsLoaded">
                <template v-if="formattedResults.length > 0">
                  <virtual-list
                    class="item-list"
                    :data-key="'uuid'"
                    :data-sources="formattedResults"
                    :data-component="itemComponent"
                    :estimate-size="60"
                    :extra-props="{parent: parentComponent}"
                  />
                </template>
                <template v-else class="container">
                  <div class="row">
                    <div class="col-12 no_result mt-5">No result found</div>
                  </div>
                </template>
							</template>
							<template v-else>
	              <div class="w-100 h-100 d-flex justify-content-center align-items-center">
	              	<spinner size="large"></spinner>
	              </div>
	            </template>
	        	</template>
        	</template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { PACKAGE } from '../../../package_constants'
import { PackageUtil } from '../../../package_utils'
import Navbar from '../../misc/components/./Navbar'
import ExploreCareerSkillProgress from './ExploreCareerSkillProgress'
import _ from 'lodash'
import CareerItem from './CareerItem'
import CareerCategoryItem from './CareerCategoryItem'
import VirtualList from 'vue-virtual-scroll-list'

export default {
  name: 'explore-career-results',
  components: {
    Navbar,
    ExploreCareerSkillProgress,
    VirtualList
  },
  data () {
    return {
      itemComponent: CareerItem,
      careerCategoryItemComponent: CareerCategoryItem,
      size: 500,
      isResultsLoaded: false,
      searchTerms: '',
      source: [
        'uuid',
        'name',
        'description',
        'category',
        'medianIncomePerYear',
        'growth',
        'openings',
        'openingsDoubleFormat',
        'currentEmployment',
        'code',
        'thumbnailURI',
        'source',
        '_score'
      ],
      sorts: [
        {name: 'Relevance', clause: [{_score: {order: 'desc'}}]},
        {name: 'Title', clause: [{'name.raw': {order: 'asc'}}]},
        {name: 'Median Income', clause: [{medianIncomePerYear: {order: 'desc'}}]},
        {name: 'Job Postings', clause: [{'openingsDoubleFormat': {order: 'desc'}}]}
      ],
      selectedSort: {},
      selectedFacetNames: [],
      facetFieldMap: {
        careerCategory: 'category.raw',
        careerIncomeRange: 'medianIncomePerYear'
      },
      filter: {},
      showCategoryDropDown: false,
      showIncomeRangeDropDown: false,
      customIncomeMin: '',
      customIncomeMax: '',
      navigationErrorMessage: 'No SOC data found for this Career. Please re-upload to see more details',
      SOURCE_EMSI: 'emsi',
      SOURCE_CAREER_ONE_STOP: 'cos',
      SOURCE_BGT: 'bgt',
      SOURCE_LIGHTCAST: 'lightcast',
      selectedCareer: null,
      skillProgressTargetId: '',
      showSkillProgressPopup: false,
      isCareerFilterClicked: false,
      isCareerSotrByClicked: false,
      showInstitutionCareerFilter: false
    }
  },

  async mounted () {
    this.initializeSearchData()
    await this.loadUserObj()
    await this.loadInstitutionPackage({uuid: this.institutionId, isAggregated: false})
    await this.loadAllBookmarks()
    await this.loadInstitutionCareers()
    setTimeout(() => {
      this.loadCareerResults()
    }, 0)
  },

  methods: {
    ...mapActions([
      'loadUserObj',
      'searchForCareers',
      'loadInstitutionPackage',
      'loadAllBookmarks',
      'loadCreateBookmarks',
      'loadDeleteBookmark',
      'saveCareerSearchState',
      'loadPlanningStream',
      'loadInstitutionCareers'
    ]),

    searchButtonClicked () {
      let searchTerms = this.searchTerms
      if (searchTerms && searchTerms.length > 0) {
        this.selectedSort = this.relevanceSort
      } else {
        this.selectedSort = this.nameSort
      }
      return this.loadCareerResults()
    },

    loadCareerResults () {
      this.saveCareerSearchState({
        terms: this.searchTerms,
        sort: { clause: this.selectedSort },
        filter: this.filter,
        selectedFacetNames: this.selectedFacetNames,
        customIncomeMin: this.customIncomeMin,
        customIncomeMax: this.customIncomeMax,
        institutionCareerFilter: this.showInstitutionCareerFilter
      })
      this.isResultsLoaded = false
      let filter = this.buildFilter()
      let facets = this.buildFacets()
      let isFacetResultsEmpty = this.isFacetResultsEmpty
      const searchInput = {
        terms: this.searchTerms,
        sort: this.selectedSort,
        source: this.source,
        from: 0,
        size: this.size,
        userId: this.userId,
        facets: facets,
        filter: filter,
        facetNames: this.allFacetNames,
        selectedFacetNames: this.selectedFacetNames
      }
      if (this.isStickyFacetsEnabled) {
        searchInput.selectedFacetNames = isFacetResultsEmpty ? this.selectedFacetNames : this.allFacetNames
      }
      this.searchForCareers(searchInput).then(res => {
        setTimeout(() => {
          this.isResultsLoaded = true
          this.loadPlanningStream()
        }, 0)
      })
    },

    goToCareerDetail (career) {
      if (!career.code) {
        return this.notifyFailure(this.navigationErrorMessage)
      }
      return this.$router.push({name: 'careerHome', params: {code: career.code}})
    },

    getCareerBookmark (career) {
      let bookmarks = this.bookmarks
      if (!bookmarks || !bookmarks.length) {
        return false
      }
      let target = false
      bookmarks.forEach(bookmark => {
        if (bookmark.entityUuid === career.uuid) {
          target = bookmark
        }
      })
      return target
    },

    openCategoryDropDown () {
      this.showCategoryDropDown = true
    },

    closeCategoryDropDown () {
      this.showCategoryDropDown = false
    },

    openIncomeRangeDropDown () {
      this.showIncomeRangeDropDown = true
    },

    closeIncomeRangeDropDown () {
      this.showIncomeRangeDropDown = false
    },

    openSortByDropDown () {
      this.isCareerSotrByClicked = true
    },

    closeSortByDropDown () {
      this.isCareerSotrByClicked = false
    },

    institutionCareerFilterSelected () {
      this.showInstitutionCareerFilter = true
      return this.loadCareerResults()
    },

    clearInstitutionCareerFilter () {
      this.showInstitutionCareerFilter = false
      return this.loadCareerResults()
    },

    isTermFilterSelected (facet, fieldName) {
      let valuesToFilter = this.filter[fieldName]
      let fieldValue = facet.key
      return valuesToFilter && valuesToFilter.includes(fieldValue)
    },

    isCustomRangeFilterActive () {
      const medianIncomePerYear = this.facetFieldMap.careerIncomeRange
      let selectedRangeFilter = this.filter[medianIncomePerYear]
      return selectedRangeFilter && selectedRangeFilter.isCustom
    },

    isRangeFilterSelected (rangeFacet, fieldName) {
      let selectedRangeFilter = this.filter[fieldName].rangeInterval
      return selectedRangeFilter && selectedRangeFilter === rangeFacet.rangeInterval
    },

    isFilterSelected (facet, fieldName) {
      return this.isTermFilterSelected(facet, fieldName) || this.isRangeFilterSelected(facet, fieldName)
    },

    filterSelected (facet, facetName) {
      const fieldName = this.facetFieldMap[facetName]
      const fieldValue = facet.key || facet.rangeInterval
      const isRangeFacet = fieldName === this.facetFieldMap.careerIncomeRange
      if (isRangeFacet) {
        this.filter[fieldName] = {
          from: facet.from,
          to: facet.to,
          rangeInterval: facet.rangeInterval,
          isCustom: facet.isCustom === true
        }
        if (!facet.isCustom) {
          this.customIncomeMin = ''
          this.customIncomeMax = ''
          this.$forceUpdate()
        }
        if (!this.selectedFacetNames.includes(facetName)) {
          // this.selectedFacetNames.push(facetName)
          this.$store.commit('ADD_CAREER_SEARCH_SELECTED_FACET_NAMES', facetName)
        }
      } else if (this.isTermFilterSelected(facet, fieldName)) {
        this.filter[fieldName] = this.filter[fieldName].filter(v => v !== fieldValue)
        const isFacetSelected = this.selectedFacetNames.includes(facetName)
        const isFacetUnused = this.filter[fieldName].length === 0
        if (isFacetSelected && isFacetUnused) {
          this.selectedFacetNames = this.selectedFacetNames.filter(v => v !== facetName)
        }
      } else {
        this.filter[fieldName].push(fieldValue)
        if (!this.selectedFacetNames.includes(facetName)) {
          // this.selectedFacetNames.push(facetName)
          this.$store.commit('ADD_CAREER_SEARCH_SELECTED_FACET_NAMES', facetName)
        }
      }
      this.loadCareerResults()
    },

    buildTermClause (fieldName, filterValues) {
      let clause = {
        'terms': {}
      }
      clause.terms[fieldName] = filterValues
      return clause
    },

    buildRangeClause (fieldName, from, to) {
      let clause = {'range': {}}
      clause.range[fieldName] = {}
      if (from) {
        clause.range[fieldName]['gte'] = from
      }
      if (to) {
        clause.range[fieldName]['lt'] = to
      }
      return clause
    },

    initializeSearchData () {
      this.showInstitutionCareerFilter = this.careerSearchInstitutionCareerFilter
      this.searchTerms = this.careerSearchTerms || ''
      this.selectedFacetNames = this.careerSearchSelectedFacetNames || []
      this.customIncomeMin = this.careerSearchCustomIncomeMin || ''
      this.customIncomeMax = this.careerSearchCustomIncomeMax || ''
      if (this.careerSearchTerms) {
        this.selectedSort = this.relevanceSort
      } else {
        this.selectedSort = this.nameSort // Always default to nameSort initially
      }
      let filter = this.careerSearchFilter
      if (this.isFilterEmpty(filter)) {
        Object.values(this.facetFieldMap).forEach(fieldName => {
          filter[fieldName] = []
        })
      }
      this.filter = filter
    },

    isFilterEmpty (filter) {
      let isEmpty = true
      filter = filter || this.filter
      Object.values(filter).forEach(filterValues => {
        isEmpty = isEmpty && !filterValues
      })
      return isEmpty
    },

    buildFilter () {
      let elasticSearchFilter = {
         'bool': {
           'must': []
         }
       }
      let filter = this.filter
      let buildTermClause = this.buildTermClause
      let buildRangeClause = this.buildRangeClause
      let medianIncomePerYear = this.facetFieldMap.careerIncomeRange
      Object.keys(filter).forEach(fieldName => {
        const isTermFacet = fieldName !== medianIncomePerYear
        const isRangeFacet = !isTermFacet
        let filterValues = filter[fieldName]
        if (isTermFacet && filterValues && filterValues.length > 0) {
          elasticSearchFilter.bool.must.push(buildTermClause(fieldName, filterValues))
        } else if (isRangeFacet && filterValues.rangeInterval) {
          elasticSearchFilter.bool.must.push(buildRangeClause(fieldName, filterValues.from, filterValues.to))
        }
      })
      // filter field 'source' => 'ONET' or 'EMSI' or 'BGT'
      elasticSearchFilter.bool.must.push(this.laborSourceFilter)
      if (this.showInstitutionCareerFilter && this.institutionCareers.length > 0 && this.isInstitutionCareersEnabled) {
        let institutionCareerFilter = {
          'terms': {
            'code.raw': this.institutionCareers
          }
        }
        elasticSearchFilter.bool.must.push(institutionCareerFilter)
      }
      return elasticSearchFilter
    },

    getFacetFilter (facetName) {
      let facetFilter = {
         'bool': {
           'must': []
         }
       }
      const isFilterEmpty = this.isFilterEmpty()
      if (!isFilterEmpty && !this.selectedFacetNames.includes(facetName)) {
        let buildFilter = this.buildFilter()
        facetFilter.bool.must = facetFilter.bool.must.concat(buildFilter.bool.must)
      }
      return facetFilter
    },

    buildFacet (field, order, facetName) {
      return {
        'aggs': {
           'termObj': {
             'terms': {
               'field': field,
               'order': order,
               'size': 1000
             }
           },
         },
        'filter': this.getFacetFilter(facetName)
      }
    },

    validateCustomRanges () {
      let customIncomeMin = this.customIncomeMin
      let customIncomeMax = this.customIncomeMax
      if (isNaN(customIncomeMin) || isNaN(customIncomeMax) || customIncomeMin < 0 || customIncomeMax < 0) {
        customIncomeMin = ''
        customIncomeMax = ''
      }
      this.customIncomeMin = customIncomeMin
      this.customIncomeMax = customIncomeMax
      this.$forceUpdate()
    },

    customRangeSelected () {
      // ignore ranges where either inputs are empty to avoid confusing UX.
      this.validateCustomRanges()
      if (!this.customIncomeMin && !this.customIncomeMax) {
        return this.isCustomRangeFilterActive() ? this.clearRangeFilter() : this.closeIncomeRangeDropDown()
      }
      let range = {from: this.customIncomeMin, to: this.customIncomeMax}
      range.rangeInterval = range.from + '-' + range.to
      if (!range.from) {
        range.rangeInterval = '< ' + range.to
      } else if (!range.to) {
        range.rangeInterval = '> ' + range.from
      }
      range.isCustom = true
      this.closeIncomeRangeDropDown()
      this.filterSelected(range, 'careerIncomeRange')
    },

    clearRangeFilter () {
      const careerIncomeRange = 'careerIncomeRange'
      const medianIncomePerYear = this.facetFieldMap[careerIncomeRange]
      this.customIncomeMin = ''
      this.customIncomeMax = ''
      this.filter[medianIncomePerYear] = {}
      this.selectedFacetNames = this.selectedFacetNames.filter(v => v !== careerIncomeRange)
      this.closeIncomeRangeDropDown()
      this.loadCareerResults()
    },

    notifySuccess (text) {
      return this.$notify({
        group: 'notify',
        type: 'success',
        title: '',
        text: text
      })
    },

    notifyFailure (text) {
      return this.$notify({
        group: 'notify',
        type: 'error',
        title: '',
        text: text
      })
    },

    addCommaInNumber (numValue) {
      return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },

    async bookmarkCareer (career) {
      const bookmark = {
        'source': 'explore',
        'entityType': 'career',
        'entityTitle': career.name,
        'entityUuid': career.uuid,
        'userId': this.userId
      }
      const response = await this.loadCreateBookmarks(bookmark)
      const message = (response ? 'Successfully bookmarked \'' : 'Unable to bookmark \'') + career.name + '\''
      const notify = response ? this.notifySuccess : this.notifyFailure
      notify(message)
      await this.loadAllBookmarks()
    },

    async deleteCareerBookmark (career) {
      await this.loadDeleteBookmark(career.bookmark.uuid)
      this.notifySuccess('Successfully deleted bookmark \'' + career.name + '\'')
      await this.loadAllBookmarks()
    },

    isBookmarked (career) {
      return career.bookmark && career.bookmark.uuid
    },

    closeDescriptionModal (modalId) {
      let descriptionModal = modalId
      //this.$refs.descriptionModal.hide()
      this.$root.$emit('bv::hide::modal', descriptionModal)
    },

    getExploreSearchPackage () {
      let packages = this.packages
      if (!packages || !packages.length || packages.length <= 0) {
        return {}
      }
      return PackageUtil.getExploreSearchPackage(packages)
    },

    buildFacets () {
      const termOrder = {'_key': 'asc'}
      let buildFacet = this.buildFacet
      let getFacetFilter = this.getFacetFilter
      let facets = {
        'careerCategory': buildFacet('category.raw', termOrder, 'careerCategory'),
        'careerIncomeRange': {
          'aggs': {
 	          'rangeObj': {
 	            'range': {
 	              'field': 'medianIncomePerYear',
 	              'ranges': [
 	              	{'to': 25000},
 	              	{'from': 25000, 'to': 50000},
 	              	{'from': 50000, 'to': 75000},
 	              	{'from': 75000}
 	              ]
 	            }
 	          }
 	        },
 	        'filter': getFacetFilter('careerIncomeRange')
        }
      }
      return facets
    },
    calculateSkillProgressClicked (career, event) {
      this.selectedCareer = career
      this.skillProgressTargetId = event.target.id
      this.showSkillProgressPopup = true
    },
    selectedFilterCount () {
      if (this.isFilterEmpty(this.careerSearchFilter)) {
        return 0
      }
      let count = this.careerSearchFilter['category.raw'].length
      count += ((!_.isEmpty(this.careerSearchFilter.medianIncomePerYear)) ? 1 : 0)
      count += (this.careerSearchInstitutionCareerFilter ? 1 : 0)
      return count
    }
  },
  computed: {
    ...mapState({
      'userObj': state => state.login.userObj,
      'enabledFeatures': state => state.dashboard.enabledFeatures,
      'packages': state => state.dashboard.packages,
      'careerFacetResults': state => state.explore.careerFacetResults,
      'careerSearchResults': state => state.explore.careerSearchResults,
      'bookmarks': state => state.explore.bookmarks,
      'careerSearchTerms': state => state.explore.careerSearchTerms,
      'careerSearchSort': state => state.explore.careerSearchSort,
      'careerSearchFilter': state => state.explore.careerSearchFilter,
      'careerSearchSelectedFacetNames': state => state.explore.careerSearchSelectedFacetNames,
      'careerSearchCustomIncomeMin': state => state.explore.careerSearchCustomIncomeMin,
      'careerSearchCustomIncomeMax': state => state.explore.careerSearchCustomIncomeMax,
      'planningStream': state => state.dashboard.stream,
      'total': state => state.explore.careerTotal,
      'institutionCareers': state => state.explore.institutionCareers,
      'careerSearchInstitutionCareerFilter': state => state.explore.careerSearchInstitutionCareerFilter
    }),
    parentComponent () {
      return this
    },
    userId () {
      return this.userObj.uuid
    },
    institutionId () {
      return this.userObj.institutionId
    },
    showDescriptionOnResult () {
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.searchResultDescription) {
        return false
      }
      return exploreCareersFlagMap.searchResultDescription.enabled
    },
    exploreCareersFlagMap () {
      let featureId = PACKAGE.FEATURE_IDS.EXPLORE_CAREERS
      let exploreSearchPackage = this.getExploreSearchPackage()
      return PackageUtil.getFlagsFromPackageFeature(exploreSearchPackage, featureId)
    },
    showMedianIncomeOnResult () {
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.searchResultMedianIncome) {
        return false
      }
      return exploreCareersFlagMap.searchResultMedianIncome.enabled
    },
    medianIncomeResultLabel () {
      const defaultLabel = 'median income'
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.searchResultMedianIncome) {
        return defaultLabel
      }
      return exploreCareersFlagMap.searchResultMedianIncome.label || defaultLabel
    },
    showJobPostingsOnResult () {
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.searchResultJobPosting) {
        return false
      }
      return exploreCareersFlagMap.searchResultJobPosting.enabled
    },
    jobPostingsResultLabel () {
      const defaultLabel = 'job postings'
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.searchResultJobPosting) {
        return defaultLabel
      }
      return exploreCareersFlagMap.searchResultJobPosting.label || defaultLabel
    },
    showGrowthRateOnResult () {
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.searchResultGrowthRate) {
        return false
      }
      return exploreCareersFlagMap.searchResultGrowthRate.enabled
    },
    growthRateResultLabel () {
      const defaultLabel = 'growth rate'
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.searchResultGrowthRate) {
        return defaultLabel
      }
      return exploreCareersFlagMap.searchResultGrowthRate.label || defaultLabel
    },
    showBookmarkOnResult () {
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.searchResultBookMark) {
        return false
      }
      return exploreCareersFlagMap.searchResultBookMark.enabled
    },
    isSortByEnabled () {
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.sortBy) {
        return false
      }
      return exploreCareersFlagMap.sortBy.enabled
    },
    isSortByRelevanceEnabled () {
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.sortByRelevance) {
        return false
      }
      return exploreCareersFlagMap.sortByRelevance.enabled
    },
    sortByRelevanceLabel () {
      const defaultLabel = 'Relevance'
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.sortByRelevance) {
        return defaultLabel
      }
      return exploreCareersFlagMap.sortByRelevance.label || defaultLabel
    },
    isSortByTitleEnabled () {
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.sortByTitle) {
        return false
      }
      return exploreCareersFlagMap.sortByTitle.enabled
    },
    sortByTitleLabel () {
      const defaultLabel = 'Title'
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.sortByTitle) {
        return defaultLabel
      }
      return exploreCareersFlagMap.sortByTitle.label || defaultLabel
    },
    isSortByMedianIncomeEnabled () {
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.sortByMedianIncome) {
        return false
      }
      return exploreCareersFlagMap.sortByMedianIncome.enabled
    },
    sortByMedianIncomeLabel () {
      const defaultLabel = 'Median Income'
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.sortByMedianIncome) {
        return defaultLabel
      }
      return exploreCareersFlagMap.sortByMedianIncome.label || defaultLabel
    },
    isSortByJobPostingEnabled () {
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.sortByJobPosting) {
        return false
      }
      return exploreCareersFlagMap.sortByJobPosting.enabled
    },
    sortByJobPostingsLabel () {
      const defaultLabel = 'Job Postings'
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.sortByJobPosting) {
        return defaultLabel
      }
      return exploreCareersFlagMap.sortByJobPosting.label || defaultLabel
    },
    sortByOptions () {
      let options = []
      let sorts = this.sorts
      if (this.isSortByRelevanceEnabled) {
        sorts[0].name = this.sortByRelevanceLabel
        options.push(sorts[0])
      }
      if (this.isSortByTitleEnabled) {
        sorts[1].name = this.sortByTitleLabel
        options.push(sorts[1])
      }
      if (this.isSortByMedianIncomeEnabled) {
        sorts[2].name = this.sortByMedianIncomeLabel
        options.push(sorts[2])
      }
      if (this.isSortByJobPostingEnabled) {
        sorts[3].name = this.sortByJobPostingsLabel
        options.push(sorts[3])
      }
      return options
    },
    isInstitutionCareersEnabled () {
      let institutionCareersFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.INSTITUTION_CAREERS]
      if (institutionCareersFeature) {
        return institutionCareersFeature.enabled
      }
      return false
    },
    institutionCareersLabel () {
      let institutionCareersFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.INSTITUTION_CAREERS]
      if (institutionCareersFeature && institutionCareersFeature.label) {
        return institutionCareersFeature.label
      }
      return 'Only Institution Careers'
    },
    isSearchBarEnabled () {
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.searchCareers) {
        return false
      }
      return exploreCareersFlagMap.searchCareers.enabled
    },
    isCareerInterestEnabled () {
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.selectCareerInterest) {
        return false
      }
      return exploreCareersFlagMap.selectCareerInterest.enabled
    },
    careerInterestLabel () {
      const defaultLabel = 'Career Interest'
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.selectCareerInterest) {
        return defaultLabel
      }
      return exploreCareersFlagMap.selectCareerInterest.label || defaultLabel
    },
    isIncomeRangeEnabled () {
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.selectIncomeRange) {
        return false
      }
      return exploreCareersFlagMap.selectIncomeRange.enabled
    },
    incomeRangeLabel () {
      const defaultLabel = 'Income Range'
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.selectIncomeRange) {
        return defaultLabel
      }
      return exploreCareersFlagMap.selectIncomeRange.label || defaultLabel
    },
    laborSourceFilter () {
      if (this.isEMSIFeatureEnabled) {
        return this.buildTermClause('source', [this.SOURCE_EMSI])
      }
      if (this.isBGTFeatureEnabled) {
        return this.buildTermClause('source', [this.SOURCE_BGT])
      }
      if (this.isLightcastFeatureEnabled) {
        return this.buildTermClause('source', [this.SOURCE_LIGHTCAST])
      }
      return this.buildTermClause('source', [this.SOURCE_CAREER_ONE_STOP])
    },
    isEMSIFeatureEnabled () {
      let emsiFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_SEARCH_EMSI_SOURCE]
      return emsiFeature && emsiFeature.enabled
    },
    isBGTFeatureEnabled () {
      let bgtFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_SEARCH_BGT_SOURCE]
      return bgtFeature && bgtFeature.enabled
    },
    isLightcastFeatureEnabled () {
      let lightcastFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_SEARCH_LIGHTCAST_SOURCE]
      return lightcastFeature && lightcastFeature.enabled
    },
    isExplorePackageEnabled () {
      let exploreFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_FEATURE_ID]
      if (exploreFeature && exploreFeature.enabled) {
        return true
      }
      return false
    },
    formattedFacetResults () {
      let formattedFacetResults = {}
      let facetResults = this.careerFacetResults
      let facetFieldMap = this.facetFieldMap
      let isTermFilterSelected = this.isTermFilterSelected
      let isRangeFilterSelected = this.isRangeFilterSelected
      let currencyLabel = this.currencyLabel
      let addCommaInNumber = this.addCommaInNumber
      this.allFacetNames.forEach((facetName) => {
        const fieldName = facetFieldMap[facetName]
        let facetResult = (facetResults && facetResults[facetName]) ? _.cloneDeep(facetResults[facetName]) : {}
         if (facetResult && Object.keys(facetResult).length > 0) {
           let isRangeFacet = Object.keys(facetResult).includes('rangeObj')
           if (isRangeFacet) {
            facetResult = _.cloneDeep(facetResult.rangeObj.buckets)
            facetResult.forEach((range) => {
              if (!range.from) {
                let formatted = addCommaInNumber(range.to)
                range.rangeInterval = '< ' + formatted
                range.label = '< ' + currencyLabel + formatted
              } else if (!range.to) {
                let formatted = addCommaInNumber(range.from)
                range.rangeInterval = '> ' + formatted
                range.label = '>= ' + currencyLabel + formatted
              } else if (range.to && range.from) {
                range.rangeInterval = range.from + '-' + range.to
                range.label = (currencyLabel + addCommaInNumber(range.from)) + '-' + (currencyLabel + addCommaInNumber(range.to))
              }
              range.isSelected = isRangeFilterSelected(range, fieldName)
            })
          } else {
            facetResult = facetResult.termObj.buckets
            facetResult.forEach((termFacet) => {
              termFacet.isSelected = isTermFilterSelected(termFacet, fieldName)
            })
          }
        }
        formattedFacetResults[facetName] = facetResult
      })
      return formattedFacetResults
    },
    formattedResults () {
      let formatted = []
      let results = this.careerSearchResults
      if (!results || results.length <= 0) {
        return formatted
      }
      let isEMSIFeatureEnabled = this.isEMSIFeatureEnabled
      let isBGTFeatureEnabled = this.isBGTFeatureEnabled
      let isLightcastFeatureEnabled = this.isLightcastFeatureEnabled
      let getBookmark = this.getCareerBookmark
      results.forEach(function (career) {
        let elasticSearchDocument = career.elasticSearchDocument
        career.code = elasticSearchDocument.code
        career.medianIncomePerYear = elasticSearchDocument.medianIncomePerYear
        career.growth = elasticSearchDocument.growth
        career.openings = elasticSearchDocument.openings
        career.thumbnailURI = elasticSearchDocument.thumbnailURI
        career.bookmark = getBookmark(career)
        if ((isEMSIFeatureEnabled || isBGTFeatureEnabled || isLightcastFeatureEnabled) && career.growth) {
          career.growth = career.growth + ' %'
        }
        formatted.push(career)
      })
      return formatted
    },
    allFacetNames () {
      return Object.keys(this.facetFieldMap)
    },
    fieldsToFilter () {
      return Object.values(this.facetFieldMap)
    },
    currencyLabel () {
      return '$'
    },
    relevanceSort () {
      return this.sorts[0].clause
    },
    nameSort () {
      return this.sorts[1].clause
    },
    isFacetResultsEmpty () {
      let isEmpty = true
      let formattedFacetResults = this.formattedFacetResults
      this.allFacetNames.forEach(facetName => {
        let facetResult = formattedFacetResults[facetName]
        if (facetName === 'careerIncomeRange' && facetResult.length > 0) {
          facetResult.forEach((range) => {
            isEmpty = isEmpty && range.doc_count === 0
          })
        } else {
          isEmpty = isEmpty && (!facetResult || facetResult.length === 0)
        }
      })
      return isEmpty
    },
    exploreSearchFlagMap () {
      let featureId = PACKAGE.FEATURE_IDS.EXPLORE_SEARCH_FEATURE_ID
      let exploreSearchPackage = this.getExploreSearchPackage()
      return PackageUtil.getFlagsFromPackageFeature(exploreSearchPackage, featureId)
    },
    isStickyFacetsEnabled () {
      let exploreSearchFlagMap = this.exploreSearchFlagMap
      if (!exploreSearchFlagMap || !exploreSearchFlagMap.enableStickyFacets) {
        return false
      }
      return this.exploreSearchFlagMap.enableStickyFacets.enabled
    },
    showFacetCounts () {
      let exploreSearchFlagMap = this.exploreSearchFlagMap
      if (!exploreSearchFlagMap || !exploreSearchFlagMap.showFacetCounts) {
        return false
      }
      return this.exploreSearchFlagMap.showFacetCounts.enabled
    },
    showCalculateRequiredSkillOnResult () {
      let exploreCareersFlagMap = this.exploreCareersFlagMap
      if (!exploreCareersFlagMap || !exploreCareersFlagMap.searchResultCalculateRequiredSkill) {
        return false
      }
      return exploreCareersFlagMap.searchResultCalculateRequiredSkill.enabled
    },
    isStudentLogin () {
      let role = this.userObj.roles[0].role
      return (role === 'Student')
    }
  },
  watch: {
    showCategoryDropDown (newValue, oldValue) {
      if (newValue) {
        this.closeIncomeRangeDropDown()
        this.closeSortByDropDown()
      }
    },
    showIncomeRangeDropDown (newValue, oldValue) {
      if (newValue) {
        this.closeCategoryDropDown()
        this.closeSortByDropDown()
      }
    },
    isCareerFilterClicked (newValue, oldValue) {
      if (newValue) {
        this.closeSortByDropDown()
      }
    },
    isCareerSotrByClicked (newValue, oldValue) {
      if (newValue) {
        this.isCareerFilterClicked = false
        this.closeCategoryDropDown()
        this.closeIncomeRangeDropDown()
      }
    },
    selectedSort (newSort, oldSort) {
      if ((newSort.length > 0) && (oldSort.length > 0)) {
        this.loadCareerResults()
      }
    }
  }
}
</script>

<style scoped>
  .item-list {
    overflow-y: auto;
    overflow-x: hidden;
    height: calc(100vh - 210px);
  }

  .facet-item-list {
    overflow-y: auto;
    overflow-x: hidden;
    max-height: calc(100vh - 340px);
  }
</style>



// WEBPACK FOOTER //
// src/app/explore/components/ExploreCareerResults.vue